import fileApi from "@/apis/File.api";
import axios from "axios";
import i18n from "@/plugins/i18n";
import notifyHelper from "@/helpers/notifyHelper";

const state = {
    form: {
        fileName: "",
        contentType: "",
        size: 0,
        idSite: "",
        uploadAction: "",
    },
    isLoading: false,
};
const getters = {
    isLoading: state => state.isLoading,
    uploadAction: state => state.form.uploadAction,
};
const mutations = {
    SET_FILE: (state, file) => {
        state.form.fileName = file.name;
        state.form.contentType = file.type;
        state.form.size = file.size;
        state.form.idSite = file.idSite;
    },
    SET_LOADING: (state, payload) => {
        state.isLoading = payload;
    },
    SET_UPLOAD_ACTION: (state, payload) => {
        state.form.uploadAction = payload;
    }
};
const actions = {
    setFile: ({commit, rootGetters}, payload) => {
        payload.idSite = rootGetters["app/idSite"];
        commit("SET_FILE", payload);
    },
    uploadS3: async ({commit}, {url, file}) => {
        const response = await axios.put(url, file, {
            transformRequest: (data, headers) => {
                delete headers.common["Authorization"];
                return data;
            },
            headers: {
                "Content-Type": file.type,
                "x-amz-acl": "public-read",
            },
        });
        if (response.status !== 200) {
            notifyHelper.error(i18n.t("File upload failed!"));
            return false;
        }
        return true;
    },
    insertFile: async ({commit}, {idFile, idSite}) => {
        const response = await fileApi.InsertFile({idFile, idSite: idSite});
        if (response.error) return false;
        return {
            id: response.data.id,
            name: response.data.name,
            url: response.data.url,
            contentType: response.data.contentType,
            type: response.data.type,
        }
    },
    uploadFile: async ({commit, dispatch, state}, {file, idSite}) => {
        dispatch("setFile", file);
        commit("SET_LOADING", true);
        const response = await fileApi.GetUploadUrl(state.form);
        if (response.error) {
            commit("SET_LOADING", false);
            return false;
        }
        const {idFile, uploadUrl} = response.data;
        const uploadResponse = await dispatch("uploadS3", {file, url: uploadUrl})
        if (!uploadResponse) {
            commit("SET_LOADING", false);
            return false;
        }
        const result = await dispatch("insertFile", {idFile: idFile, idSite: idSite})
        commit("SET_LOADING", false);
        return result;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
